import { Box } from "@mui/material";
import { styled } from "@mui/system";

const WidgetWrapper = styled(Box)(({ theme }) => ({
  padding: "1.5rem 1.5rem 0.75rem 1.5rem",
  backgroundColor: theme.palette.background.alt,
  borderRadius: "0.75rem",
  boxShadow: theme.palette.mode === "dark"
    ? "0 2px 8px rgba(0,0,0,0.45)"
    : "0 2px 8px rgba(0,0,0,0.08)",
}));

export default WidgetWrapper;
